import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { fetchSearchICD10, type SearchICD10ResponseT } from '../api/searchICD10.js';
import { labsKeys } from './keys.js';

export function useSearchICD10Query(query: string, enabled = true) {
  return useQuery<SearchICD10ResponseT>({
    queryKey: labsKeys.icd10Search(query),
    queryFn: ({ signal }) => fetchSearchICD10({ query, mode: 'fulltextsearch', topK: 15 }, signal),
    enabled: enabled && query.trim().length >= 2,
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
}
